import { Pipe, PipeTransform } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { SigningState } from 'ngx-mat-esign360/lib/transaction/model/signing-state.model';

@Pipe({
  name: 'signingStateName',
})
export class SigningStateNamePipe implements PipeTransform {
  transform(state: SigningState): string {
    switch (state) {
      case SigningState.NotStarted:
        return marker('SIGNING_STATES.NOT_STARTED');
      case SigningState.InProcess:
        return marker('SIGNING_STATES.IN_PROCESS');
      case SigningState.Finished:
        return marker('SIGNING_STATES.DONE');
      case SigningState.Refused:
        return marker('SIGNING_STATES.REFUSED');
      case SigningState.Cancelled:
        return marker('SIGNING_STATES.CANCELED');
      case SigningState.Timeout:
        return marker('SIGNING_STATES.TIMEOUT');
      case SigningState.Error:
        return marker('SIGNING_STATES.ERROR');
      case SigningState.Blocked:
        return marker('SIGNING_STATES.BLOCKED');
      default:
        throw new Error(`Unknown signing state: ${state}`);
    }
  }
}
